import React from 'react';
import PublicLayout from './PublicLayout';
import { Documentation } from '../Documentation';

const Docs = () => {
  return (
    <PublicLayout>
      <Documentation />
    </PublicLayout>
  );
};

export default Docs;

